import { Component, ChangeDetectionStrategy, computed } from '@angular/core';
import { Navbar } from './navbar';
import { Wwww } from './inicio3d';
import { isAuth } from './auth';

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [
    Navbar, 
    Wwww
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-navbar />
    <app-www />
  `
})
export class InicioComponent {
  // Estado de autenticación optimizado para solo lectura
  readonly auth = isAuth();
}